const API_URL = process.env.REACT_APP_API_URL;

const procesarRespuesta = async (res, msgDefault) => {
  const data = await res.json().catch(() => ({}));
  if (!res.ok || data.success === false) {
    throw new Error(data.message || msgDefault);
  }
  return data;
};

// ==========================================
// 1. EMPLEADOS Y CÓDIGOS INTERNOS
// ==========================================
export const getEmpleadosHorarios = async () => {
  const res = await fetch(`${API_URL}/api/horarios/empleados`);
  return procesarRespuesta(res, "Error obteniendo empleados");
};

export const asignarCodigoEmpleado = async (id, sede_id, cargo_id) => {
  const res = await fetch(`${API_URL}/api/horarios/empleados/${id}/generar-codigo`, {
    method: 'PUT',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ sede_id, cargo_id })
  });
  return procesarRespuesta(res, "Error al generar código interno");
};

export const autoAsignarCodigosSysplus = async () => {
  const res = await fetch(`${API_URL}/api/horarios/empleados/auto-asignar`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' }
  });
  return procesarRespuesta(res, "Error al auto-asignar códigos masivamente");
};

// ==========================================
// 2. CONFIGURACIÓN GERENCIAL UNIFICADA Y SEDES
// ==========================================
export const getSedesHorarios = async () => {
  const res = await fetch(`${API_URL}/api/horarios/sedes`);
  return procesarRespuesta(res, "Error obteniendo sedes");
};

export const actualizarPlantaSede = async (id, planta_autorizada, detalle_planta) => {
  const res = await fetch(`${API_URL}/api/horarios/sedes/${id}/planta`, {
    method: 'PUT',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ planta_autorizada, detalle_planta })
  });
  return procesarRespuesta(res, "Error al actualizar planta de la sede");
};

export const getConfiguracionGerencialApi = async () => {
  const res = await fetch(`${API_URL}/api/horarios/configuracion-gerencial`);
  return procesarRespuesta(res, "Error obteniendo configuración gerencial");
};

export const guardarConfiguracionGerencialApi = async (data) => {
  const res = await fetch(`${API_URL}/api/horarios/configuracion-gerencial`, {
    method: 'PUT',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(data)
  });
  return procesarRespuesta(res, "Error guardando configuración gerencial");
};

export const getCargosHorarios = async () => {
  const res = await fetch(`${API_URL}/api/horarios/cargos`);
  return procesarRespuesta(res, "Error obteniendo cargos");
};

export const crearCargo = async (nombre, prefijo) => {
  const res = await fetch(`${API_URL}/api/horarios/cargos`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ nombre, prefijo })
  });
  return procesarRespuesta(res, "Error al crear el cargo");
};

export const actualizarPrefijoSede = async (id, prefijo) => {
  const res = await fetch(`${API_URL}/api/horarios/sedes/${id}/prefijo`, {
    method: 'PUT',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ prefijo })
  });
  return procesarRespuesta(res, "Error al actualizar prefijo");
};

// ==========================================
// 3. TURNOS Y CALENDARIO
// ==========================================
export const getTurnos = async () => {
  const res = await fetch(`${API_URL}/api/horarios/turnos`);
  return procesarRespuesta(res, "Error obteniendo turnos");
};

export const getTiposTurno = async () => {
  const res = await fetch(`${API_URL}/api/horarios/tipos-turno`);
  return procesarRespuesta(res, "Error obteniendo tipos de turno");
};

// FIX: Acepta los parámetros separados exactamente como los manda el Calendario
export const crearTurno = async (empleado_id, fecha, id_turno, es_cobertura = 0) => {
  const res = await fetch(`${API_URL}/api/horarios/turnos`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ empleado_id, fecha, id_turno, es_cobertura })
  });
  return procesarRespuesta(res, "Error al crear turno");
};

export const actualizarTurno = async (id, data) => {
  const res = await fetch(`${API_URL}/api/horarios/turnos/${id}`, {
    method: 'PUT',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(data)
  });
  return procesarRespuesta(res, "Error al actualizar turno");
};

// NUEVO: Función para el botón de "Marcar como Descanso (Borrar turno)"
export const eliminarTurnoDia = async (empleado_id, fecha) => {
  const res = await fetch(`${API_URL}/api/horarios/turnos/${empleado_id}/${fecha}`, {
    method: 'DELETE'
  });
  return procesarRespuesta(res, "Error al marcar como descanso");
};

export const generarMesAutomatico = async (anio, mes, sede_prefijo = '') => {
  const res = await fetch(`${API_URL}/api/horarios/generar-mes`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ anio, mes, sede_prefijo })
  });
  return procesarRespuesta(res, "Error al generar el mes automáticamente");
};

// ==========================================
// 4. NOVEDADES Y HORAS EXTRAS (GERENCIA)
// ==========================================
export const getNovedades = async () => {
  const res = await fetch(`${API_URL}/api/horarios/novedades`);
  return procesarRespuesta(res, "Error obteniendo novedades");
};

export const crearNovedad = async (data) => {
  const res = await fetch(`${API_URL}/api/horarios/novedades`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(data)
  });
  return procesarRespuesta(res, "Error al registrar la novedad");
};

export const actualizarEstadoNovedad = async (id, estado_aprobacion, aprobado_por = 'GERENCIA') => {
  const res = await fetch(`${API_URL}/api/horarios/novedades/${id}/estado`, {
    method: 'PUT',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ estado_aprobacion, aprobado_por })
  });
  return procesarRespuesta(res, "Error al actualizar estado de la solicitud");
};

export const eliminarNovedadApi = async (id) => {
  const res = await fetch(`${API_URL}/api/horarios/novedades/${id}`, {
    method: 'DELETE'
  });
  return procesarRespuesta(res, "Error al eliminar la novedad");
};

// ==========================================
// 5. REPORTES
// ==========================================
export const getReporteHorarios = async (mes, sede_id = '') => {
  const url = sede_id 
    ? `${API_URL}/api/horarios/reportes?mes=${mes}&sede_id=${sede_id}`
    : `${API_URL}/api/horarios/reportes?mes=${mes}`;
  const res = await fetch(url);
  return procesarRespuesta(res, "Error al obtener el reporte");
};